export enum RoundingMethods {
    ROUNDING_METHOD_DOWN = 'Always Round Down',
    ROUNDING_METHOD_UP = 'Always Round Up',
    ROUNDING_METHOD_MIDDLE = 'Round Up Past Halfway Point',
}

export enum InterestMethods {
    SIMPLE_DAILY = 'Simple Daily',
    SIMPLE_MONTHLY = 'Simple Monthly',
    FLAT_MONTHLY = 'Flat Monthly Fee',
}

/** How a lead (consult) invoice shows its Period (OWA-987). */
export enum LeadPeriodChoices {
    UP_TO_CONSULT = 'Up to Consult Date',
    FULL_RANGE = 'Full Range',
    HIDE = 'Hide It',
}

/**
 * Which Events appear on Calendars when the firm has not chosen (OWA-1313): Case and Lead Events,
 * not Contact Events. A category listed under `categories` decides for itself, whatever its owner.
 * The Rust rules (outlaw_practice_types::calendar::settings) read the same JSON.
 */
export const DEFAULT_CALENDAR_EVENT_KINDS = JSON.stringify({
    owners: {case: true, lead: true, contact: false},
    categories: {},
});

// Constants for option values
// export default {
//     ROUNDING_METHOD_DOWN: 'Always Round Down',
//     ROUNDING_METHOD_UP: 'Always Round Up',
//     ROUNDING_METHOD_MIDDLE: 'Round Up Past Halfway Point',
// }
